export const MSGS = {
  CHANGE_PASSWORD_SUCCESS: "Password updated successfully",
};

export default MSGS;
